import { memo } from 'react'
import { useIntl } from 'react-intl'

import SolidUnlockAltIcon from 'LuxKit/Icons/solid/SolidUnlockAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

function PropertyGuestPublicRateSignUpPrompt() {
  const intl = useIntl()

  return <BodyTextBlock variant="medium" weight="bold" colour="success-dark" startIcon={<SolidUnlockAltIcon />}>
    {intl.formatMessage({
      id: '6lcYX0hO_9WfbsKDSXL7',
      defaultMessage: 'Log in to see the best price',
      description: 'Prompt underneath public(/B2C) rate pricing shown to logged-out users, hinting that logging in may reveal cheaper non-public(/CUG) rate pricing',
    })}
  </BodyTextBlock>
}

export default memo(PropertyGuestPublicRateSignUpPrompt)
